import { insertFigure, deleteFigure, getNode, setActiveTool } from "../../../commands/custom-commands";
import { customSchema } from "../../../schemas/custom-schema";

export default class FigureTool {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buildContainer();
    this.buildDialog();
    this.bindActions();
    containerElement.appendChild(this.containerElement);
    this.update(editorView);
  }

  buildContainer() {
    this.containerElement = document.createElement("div");
    this.containerElement.className = "editor-button-container";
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.style.anchorName = "--figure-anchor";
    this.buttonElement.dataset.action = "figure";
    this.buttonElement.setAttribute("aria-expanded", "false");
    this.buttonElement.title =" Imagen";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Imagen";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Imagen";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.containerElement.appendChild(this.buttonElement);
  }

  buildDialog() {
    const buttonsContainer = document.createElement("div"),
      targetInputContainer = document.createElement("div"),
      targetLabel = document.createElement("label");

    this.dialogElement = document.createElement("div");
    this.dialogElement.className = "editor-dialog";
    this.dialogElement.style.positionAnchor ="--figure-anchor";
    this.urlInput = document.createElement("input");
    this.urlInput.setAttribute("placeholder", "URL");
    this.urlInput.className = "editor-input";
    //this.urlInput.required = true;
    this.urlInput.type = "text";
    
    targetInputContainer.className = "editor-checkbox-container";
    this.targetInput = document.createElement("input");
    this.targetInput.type = "checkbox";
    this.targetInput.className = "editor-checkbox";
    targetLabel.textContent = "Incluir pie de gráfico";
    targetLabel.className = "editor-checkbox-label";
    targetInputContainer.appendChild(this.targetInput);
    targetInputContainer.appendChild(targetLabel);

    this.submitButton = document.createElement("button");
    this.submitButton.type = "button";
    this.submitButton.className = "editor-button";
    this.submitButton.textContent = "Agregar";

    buttonsContainer.className = "editor-buttons-container";
    buttonsContainer.appendChild(this.submitButton);

    this.dialogElement.appendChild(this.urlInput);
    this.dialogElement.appendChild(targetInputContainer);
    this.dialogElement.appendChild(buttonsContainer);

    this.containerElement.appendChild(this.dialogElement);
  }

  bindActions() {
    this.buttonAction = this.buttonClickCallback();
    this.submitAction = this.submitButtonClickCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.submitButton.addEventListener("click", this.submitAction);
  }

  update(view) {
    const node = getNode(view.state, customSchema.nodes.figure) || getNode(view.state, customSchema.nodes.figureGraphic),
      nodeAttrs = node?.attrs,
      isEnabled = insertFigure(null, false)(view.state, null);
    if(!!node) { 
      this.urlInput.value = node.content.content[0].attrs.src;
      this.targetInput.checked = node.content.content.length === 2; 
      this.buttonElement.setAttribute("aria-pressed", "true");
    } else {
      this.urlInput.value = null;
      this.targetInput.checked = false;
      this.buttonElement.setAttribute("aria-pressed", "false");
    }

    this.buttonElement.disabled = !isEnabled;
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.submitButton.removeEventListener("submit", this.submitAction);
    this.containerElement.remove();
    this.containerElement = null;
    this.buttonElement = null;
    this.urlInput = null;
    this.targetInput = null;
    this.submitButton = null;
    this.dialogElement = null;
    this.buttonAction = null;
    this.submitAction = null;
  }

  buttonClickCallback() {
    return () => {
      setActiveTool(this.buttonElement)(this.view.state, this.view.dispatch);
    }
  }

  submitButtonClickCallback() {
    return (event) => {
      const { value: href } = this.urlInput,
        { checked: withCaption } = this.targetInput,
        isActive = getNode(this.view.state, customSchema.nodes.figure) || getNode(this.view.state, customSchema.nodes.figureGraphic);

      if(!insertFigure(null, withCaption)(this.view.state, null)) {
        return false;
      }

      if(isActive) {
        deleteFigure(this.view.state, this.view.dispatch, this.view);
      }
      insertFigure(href, withCaption)(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }
}
